@import (reference) '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../shared-classes.module.less';

.print-alert-icon {
  @CircularAlertCountDecoration();

  &.single-digit {
    right: -1px;
  }

  &.double-digit {
    right: -6px;
  }

  &.triple-digit {
    right: -7.5px;
    padding: 0 2px 1px 3px;
  }
}
